// extracted by mini-css-extract-plugin
export default {"error":"MsgPreview_error__5sJuc"};